import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import BookingLesson from '@/components/pages/BookingLesson'
import BookingTeacher from '@/components/pages/BookingTeacher'
import BookingLessonGroup from '@/components/pages/BookingLessonGroup'
import deviceTest from '@/components/pages/deviceTest'
import SimpleDeviceTest from '@/components/pages/SimpleDeviceTest'
import AttendanceRecord from '@/components/pages/AttendanceRecord'
import PersonalInfo from '@/components/pages/PersonalInfo'
import VideoCourseHome from '@/components/pages/VideoCourseHome'
import VideoClassPage from '@/components/pages/VideoClassPage'
import CheckDeviceTest from '@/components/pages/CheckDeviceTest'



Vue.use(Router)

export default new Router({
    routes: [{
            // path: '/',
            path: '/index',
            name: 'Home',
            component: Home,
            props: true,
        },
        {
            path: '/BookingLesson',
            name: 'BookingLesson',
            component: BookingLesson
        },
        {
            path: '/BookingLessonGroup',
            name: 'BookingLessonGroup',
            component: BookingLessonGroup
        },
        {
            path: '/BookingTeacher',
            name: 'BookingTeacher',
            component: BookingTeacher,
        },
        {
            path: '/deviceTest',
            name: 'deviceTest',
            component: deviceTest,
            props: true,
        },
        {
            path: '/SimpleDeviceTest',
            name: 'SimpleDeviceTest',
            component: SimpleDeviceTest,
        },
        {
            path: '/AttendanceRecord',
            name: 'AttendanceRecord',
            component: AttendanceRecord,
        },
        {
            path: '/PersonalInfo',
            name: 'PersonalInfo',
            component: PersonalInfo,
        },
        {
            path: '/Video',
            name: 'VideoCourseHome',
            component: VideoCourseHome,
            props: true,
        },
        {
            path: '/VideoClass',
            name: 'VideoClassPage',
            component: VideoClassPage,
            props: true,
        },
        {
            path: '/CheckDeviceTest',
            name: 'CheckDeviceTest',
            component: CheckDeviceTest,
            props: true,
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js